import React from 'react'
import GroupedByUserGraph from './GroupedByUserGraph'

// Group by plant name from event_data
const groupByPlantFunc = (record) => {
  let plant = ''
  try {
    plant =
      typeof record.eventData === 'string'
        ? JSON.parse(record.eventData).plant
        : record.eventData.plant
  } catch {
    plant = ''
  }
  return { [plant || 'Unknown']: 1 }
}

const GroupedByPlantGraph = ({ data = [], handleBarClick = null }) => {
  return (
    <GroupedByUserGraph
      data={data}
      xFieldLabel="Plant"
      stat="count"
      yFieldLabel="sessions"
      tooltipFunc={(val) => `${val} session${val === 1 ? '' : 's'}`}
      groupingFunc={groupByPlantFunc}
      handleBarClick={handleBarClick}
    />
  )
}

export default GroupedByPlantGraph
